import React, { useState, useEffect, useContext } from 'react';
import { Wallet, ArrowDownLeft, Clock, CheckCircle, Info, ChevronRight } from 'lucide-react';
import '../../../../assets/css/screens/customer/dashboard/customerWallet/CustomerWallet.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';
// const DUMMY_TRANSACTIONS = [
// //   {
// //     id: 1,
// //     jobTitle: 'Kitchen Plumbing Repair',
// //     amount: 1500,
// //     date: '14 Nov 2024',
// //     status: 'refunded',
// //   },
// //   {
// //     id: 2,
// //     jobTitle: 'House Painting - 3 Rooms',
// //     amount: 3200,
// //     date: '10 Nov 2024',
// //     status: 'refunded',
// //   },
// //   {
// //     id: 3,
// //     jobTitle: 'Electrical Wiring Fix',
// //     amount: 800,
// //     date: '05 Nov 2024',
// //     status: 'refunded',
// //   },
// ];

// const WALLET_BALANCE = DUMMY_TRANSACTIONS.reduce((sum, t) => sum + t.amount, 0);

const CustomerWallet = () => {
 const { baseUrl, authToken } = useContext(AppContext);
    const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  

  const fetchWalletBalance = async () => {
    try {

      const response = await axios.get(
        `${baseUrl}/customer/wallet`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`,
          },
        }
      );

      if (response.data.success) {
        setBalance(response.data.balance);
      }

    } catch (error) {

      console.error(
        'Wallet API Error:',
        error.response?.data || error.message
      );

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWalletBalance();
  }, []);

  const hasBalance = balance > 0;
  

  return (
    <>
    <AppNavbar />
    <div className="cw-page">

      {/* Header */}
      <div className="cw-header">
        <div className="cw-header-icon">
          <Wallet size={22} />
        </div>
        <div>
          <h2 className="cw-title">My Wallet</h2>
          <p className="cw-subtitle">Your refunded job amounts</p>
        </div>
      </div>

      {/* Balance Card */}
      <div className="cw-balance-card">
        <div className="cw-balance-card__bg1" />
        <div className="cw-balance-card__bg2" />
        <p className="cw-balance-label">Available Balance</p>
        <h1 className="cw-balance-amount">
          $ {balance.toLocaleString()}
        </h1>
        <p className="cw-balance-hint">
          Usable for future job postings on Picks4Tips
        </p>

        <div className="cw-balance-stats">
          <div className="cw-stat">
            {/* <span className="cw-stat-val">{transactions.length}</span> */}
            <span className="cw-stat-lbl">Cancelled Jobs</span>
          </div>
          <div className="cw-stat-divider" />
          <div className="cw-stat">
            <span className="cw-stat-val">
              $ {balance.toLocaleString()}
            </span>
            <span className="cw-stat-lbl">Total Refunded</span>
          </div>
        </div>
      </div>

      {/* Info banner */}
      <div className="cw-info-banner">
        <Info size={15} className="cw-info-icon" />
        <p className="cw-info-text">
          When you cancel a job, the paid amount is automatically refunded to your wallet. You can use this balance while posting future jobs.
        </p>
      </div>

      {/* Transactions */}
      {/* <div className="cw-section">
        <h3 className="cw-section-title">Refund History</h3>

        {transactions.length === 0 ? (
          <div className="cw-empty">
            <div className="cw-empty-icon">
              <Wallet size={36} />
            </div>
            <h4 className="cw-empty-title">No balance yet</h4>
            <p className="cw-empty-desc">
              If you cancel any job, your paid amount will be received in your wallet and you can use it in the future for job posting.
            </p>
          </div>
        ) : (
          <div className="cw-txn-list">
            {transactions.map((txn, idx) => (
              <div
                key={txn.id}
                className="cw-txn-item"
                style={{ animationDelay: `${idx * 0.07}s` }}
              >
                <div className="cw-txn-icon">
                  <ArrowDownLeft size={18} />
                </div>
                <div className="cw-txn-info">
                  <span className="cw-txn-title">{txn.jobTitle}</span>
                  <div className="cw-txn-meta">
                    <Clock size={11} />
                    <span>{txn.date}</span>
                    <span className="cw-txn-badge">
                      <CheckCircle size={10} />
                      Refunded
                    </span>
                  </div>
                </div>
                <span className="cw-txn-amount">
                  + Rs. {txn.amount.toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        )}
      </div> */}

    </div>
    </>
  );
};

export default CustomerWallet;